//----- AUTOGENERATED (changes will be overwritten) -------
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dGeneric from "../Foreign.Generic/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const Coordinates = x => x;
const eqCoordinates = {eq: x => y => x.lat === y.lat && x.lon === y.lon};
const ordCoordinates = {
  compare: x => y => {
    const v = Data$dOrd.ordNumber.compare(x.lat)(y.lat);
    if (v.tag === "LT") { return Data$dOrdering.LT; }
    if (v.tag === "GT") { return Data$dOrdering.GT; }
    return Data$dOrd.ordNumber.compare(x.lon)(y.lon);
  },
  Eq0: () => eqCoordinates
};
const newtypeCoordinates = {Coercible0: () => {}};
const hasFieldCoordinates = dictHasField => dictHasField;
const genericCoordinates = {to: x => x, from: x => x};
const showCoordinates = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["lat", Data$dShow.showNumberImpl(v.lat)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "lon",
            Data$dShow.showNumberImpl(v.lon)
          ]))([]));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "Coordinates"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeCoordinates = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "lat"})(Unscramble.decodeNumber1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "lon"
    })(Unscramble.decodeNumber1)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodingOpts = /* #__PURE__ */ (() => (
  {
    sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
    unwrapSingleConstructors: true,
    unwrapSingleArguments: true,
    unwrapSingleRecordArguments: true,
    fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
  }
))();
const encodeCoordinates = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Coordinates"})((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "lon"})({
        encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
      }))({reflectSymbol: () => "lat"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })()).encodeOpts(encodingOpts)
  }
))();
const decodeCoordinates = {
  decode: /* #__PURE__ */ Foreign$dGeneric.genericDecode(genericCoordinates)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "Coordinates"})(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "lon"
  })({decodeWithOptions: v => Foreign.readNumber(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "lat"})({
    decodeWithOptions: v => Foreign.readNumber(Data$dIdentity.monadIdentity)
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(encodingOpts)
};
export {
  Coordinates,
  decodeCoordinates,
  encodeCoordinates,
  encodingOpts,
  eqCoordinates,
  genericCoordinates,
  hasFieldCoordinates,
  newtypeCoordinates,
  ordCoordinates,
  showCoordinates,
  unscrambleDecodeCoordinates
};
